import React, { useEffect, useState } from 'react';
import { pagination } from '../../helpers';
import axios from 'axios';
import {fetchWrapper} from "../../helpers/fetch-wrapper";

const Pagination = ({ setBusiness }) => {
    // let total = business !== null ? `${business.data.total / 9}`.split('.').length === 2 ? parseInt(business.data.total / 9) + 1 : (business.data.total / 9) : ''
    const [currPage, setCurrPage] = useState(1);

    const [total, setTotal] = useState(0);

    const [pager, setPager] = useState({
        first: false,
        prev: false,
        tab: [],
        currentPage: 1,
        next: false,
        last: null
    });

    const handlePageChange = numPage => {
        setCurrPage(numPage);
        setBusiness(null);
        getBusiness(numPage);
    };

    const getBusiness = async (page) => {
        const { data } = await axios.get(`https://abn.happynessarl.com/api/v1/companies?page=${page}`, {});
        setPager(pagination(page, `${data.data.total / 9}`.split('.').length === 2 ? parseInt(data.data.total / 9) + 1 : (data.data.total / 9)));
        setTotal(`${data.data.total / 9}`.split('.').length === 2 ? parseInt(data.data.total / 9) + 1 : (data.data.total / 9))
        setBusiness(data);
    }


    useEffect(() => {
        getBusiness(currPage);
        setPager(pagination(currPage, total));
        return () => {
        };
    }, []);

    return total !== 0 ? <nav aria-label="Page navigation">
        <ul className="pagination justify-content-center">

            {
                pager.first
                    ? <>
                        <li className={`page-item ${currPage < 6 ? 'disabled' : ''}`} onClick={() => handlePageChange(pager.first)}>
                            <span className="page-link" title={"First Page"}>
                                <span aria-hidden="true">
                                    <i className="bi-chevron-double-left small"></i>
                                </span>
                            </span>
                        </li>
                        <li className={`page-item ${currPage < 6 ? 'disabled' : ''}`} onClick={() => handlePageChange(pager.prev)}>
                            <a className="page-link" title={"Previous"}>
                                <span aria-hidden="true">
                                    <i className="bi-chevron-left small"></i>
                                </span>
                            </a>
                        </li>
                    </>
                    : null
            }

            {
                pager.tab.length !== 0
                    ? pager.tab.map((page, idd) => {
                        return <li
                            key={idd}
                            className={`page-item ${page === pager.currentPage ? 'active' : ''}`}
                            onClick={() => handlePageChange(page)}
                        >
                            <span className="page-link">{page}</span>
                        </li>
                    })
                    : null
            }


            {
                pager.last
                    ? <>
                        <li className="page-item" onClick={() => handlePageChange(pager.next)}>
                            <span className="page-link" title="Next">
                                <span aria-hidden="true">
                                    <i className="bi-chevron-right small"></i>
                                </span>
                            </span>
                        </li>
                        <li className="page-item" onClick={() => handlePageChange(pager.last)}>
                            <span className="page-link" title="Last Page">
                                <span aria-hidden="true">
                                    <i className="bi-chevron-double-right small"></i>
                                </span>
                            </span>
                        </li>
                    </>
                    : null
            }


        </ul>
    </nav> : null;
}

export default Pagination;
